import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, Renderer2, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {

  // MOBILE
  public sidebarVisible: boolean = false;
  public mobileDropdownOpen: boolean = false;

  // DROPDOWN
  public servicesDropdownOpen: boolean = false;

  // SCROLL
  public scrollListener: boolean = true;
  public scrollFlag: string = '';
  public paddingScrollHeader = '';

  // NAVBAR STYLE
  public navbarStyle: 'transparent' | 'dark' | 'white' = 'transparent';
  private currentRoute: string = '/';

  // ACTIVE SECTION
  public activeSection: string = 'inicio';
  private scrollTicking = false;

  constructor(
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: any,
    private router: Router
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentRoute = event.url;
      setTimeout(() => {
        this.updateNavbarStyle();
      }, 0);
    });
  }

  ngOnInit(): void {
    this.currentRoute = this.router.url;
    setTimeout(() => {
      this.updateNavbarStyle();
    }, 0);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.scrollTicking) return;
      this.scrollTicking = true;
      requestAnimationFrame(() => {
        this.scrollTicking = false;
        this.updateNavbarStyle();
      });
    }
  }

  private updateNavbarStyle() {
    if (!isPlatformBrowser(this.platformId)) return;

    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    // const viewportHeight = window.innerHeight;
    const isHome = this.currentRoute === '/';
    const isSingleProject = this.currentRoute.startsWith('/proyectos/') && this.currentRoute !== '/proyectos';
    // const isProjectsList = this.currentRoute === '/proyectos';
    // const isBlog = this.currentRoute.startsWith('/blog');

    let bannerHeight = 0;

    if (isHome) {
      bannerHeight = document.getElementById('banner-home')?.offsetHeight || 0;
    } else if (isSingleProject) {
      bannerHeight = document.getElementById('single-project-banner')?.offsetHeight || 0;
    }

    if (isHome) {
      this.navbarStyle = 'white';
      this.scrollFlag = 'scroll';
    }
    else if (isSingleProject) {
      if (scrollTop < 60) {
        this.navbarStyle = 'transparent';
        this.scrollFlag = '';
      } else if (scrollTop < bannerHeight - 80) {
        this.navbarStyle = 'dark';
        this.scrollFlag = 'scroll';
      } else {
        this.navbarStyle = 'white';
        this.scrollFlag = 'scroll';
      }
    } else {
      this.navbarStyle = 'white';
      this.scrollFlag = scrollTop > 60 ? 'scroll' : '';
    }

    this.paddingScrollHeader = '0px';

    this.detectActiveSection();
  }


  private detectActiveSection() {
    if (!isPlatformBrowser(this.platformId)) return;

    if (this.router.url !== '/') {
      this.activeSection = '';
      return;
    }

    const sections = ['nosotros', 'servicios', 'contacto'];
    const scrollPosition = window.pageYOffset + 150;

    let foundSection = false;

    for (const sectionId of sections) {
      const element = document.getElementById(sectionId);
      if (element) {
        const offsetTop = element.offsetTop;
        const offsetBottom = offsetTop + element.offsetHeight;

        if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
          this.activeSection = sectionId;
          foundSection = true;
          break;
        }
      }
    }

    if (!foundSection) {
      this.activeSection = 'inicio';
    }
  }

  path: string = '';

  goTo(path: string) {
    if (!isPlatformBrowser(this.platformId)) return;

    const isHome = this.router.url === '/';
    const isInicio = path === 'inicio';

    if (isHome) {
      if (isInicio) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      this.scrollToElement(path);
      return;
    }

    this.router.navigate(['/']).then(() => {
      setTimeout(() => this.scrollToElement(path), 200);
    });
  }

  private scrollToElement(path: string) {
    const element = document.querySelector('#' + path) as HTMLElement;
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 100;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  toggleServicesDropdown() {
    this.servicesDropdownOpen = !this.servicesDropdownOpen;
  }

  closeServicesDropdown() {
    this.servicesDropdownOpen = false;
  }

  closeMobileMenu() {
    this.sidebarVisible = false;
    this.mobileDropdownOpen = false;
  }

  toggleMobileDropdown() {
    this.mobileDropdownOpen = !this.mobileDropdownOpen;
  }

  // scrollToSection(sectionId: string) {
  //   if (isPlatformBrowser(this.platformId)) {
  //     const element = document.getElementById(sectionId);
  //     if (element) {
  //       setTimeout(() => {
  //         element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //       }, 100);
  //     }
  //   }
  // }

  isLinkActive(route: string): boolean {
    return this.router.url === route;
  }

  isActiveSection(section: string): boolean {
    if (this.router.url !== '/') return false;
    return this.activeSection === section;
  }
}
